import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UISBDash = {
    name: 'SB Dashboard',
    imageUrl: './images/SBDash.png',
    imageSize: "99%",
    bradius: 20,
  };

const UISBRiskgrade = {
    name: 'SB Risk Grade',
    imageUrl: '../../images/SBRiskgrade.png',
    imageSize: "60%",
    bradius: 20,
  };

const UISBOverview = {
    name: 'SB Overview',
    imageUrl: '../../images/SBOverview.png',
    imageSize: "50%",
    bradius: 20,
  };

const UISBTop5 = {
    name: 'SB Top 5 OS',
    imageUrl: '../../images/SBTop5.png',
    imageSize: "50%",
    bradius: 20,
  };

const UISBTrendchart = {
    name: 'SB Trend Chart',
    imageUrl: '../../images/SBTrendchart.png',
    imageSize: "90%",
    bradius: 20,
  };

const UISBTop10 = {
    name: 'SB Top 10 Targets',
    imageUrl: '../../images/SBTop10.png',
    imageSize: "90%",
    bradius: 20,
  };

const UISBOSList = {
    name: 'SB OS List',
    imageUrl: '../../images/SBOSList.png',
    imageSize: "99%",
    bradius: 20,
  };

const UISBActivescans = {
    name: 'VS Active Scans',
    imageUrl: '../../images/SBActivescans.png',
    imageSize: "70%",
    bradius: 20,
  };

  const UISBLast5 = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/SBLast5.png',
    imageSize: "70%",
    bradius: 20,
  };

const UISBScheduledscans = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/SBScheduledscans.png',
    imageSize: "60%",
    bradius: 20,
  };

const UISBMitprogress = {
    name: 'Last 5 Scans',
    imageUrl: '../../images/SBMitprogress.png',
    imageSize: "70%",
    bradius: 20,
  };


export const SBDash = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Secure Baseline Dashboard</b><br/><br/>
      The Secure Baseline Scan dashboard provides an overview of how your previous or current baseline 
      scans have performed or are performing. Through this, you can determine how vulnerable your 
      instance is based on Operating System (OS) configuration settings and group policy practice. <br/><br/>
      
      The scans compare the OS configuration settings in your environment against best practice 
      benchmarks (CIS Benchmarks) to find configuration weaknesses and provide remediation options. 
      </div>
      <div style={helpimg}>
      <img
        src={UISBDash.imageUrl}
        alt={'Image of ' + UISBDash.name}
        style={{
          width: UISBDash.imageSize,
          borderRadius: UISBDash.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const SBRiskGrade = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Secure Baseline Risk Grade </b><br/><br/>
      The Secure Baseline Grade is based on a comparison of the OS configuration settings 
      on your devices against established OS configuration standards (the CIS Benchmarks). 
      The main performance grade tells you how your instance is performing in the current 
      reporting period. The previous grade displayed in the smaller font size is for the 
      previous reporting period. The percentage progress or decline since the previous 
      reporting period is also shown for easy performance tracking.<br/><br/>

      See progress in improved configuration and policy management as existing policies 
      are compared against known baseline standards for configuration management. Strengthen 
      security based on the Baseline scan results. 
      </div>
      <div style={helpimg}>
      <img
        src={UISBRiskgrade.imageUrl}
        alt={'Image of ' + UISBRiskgrade.name}
        style={{
          width: UISBRiskgrade.imageSize,
          borderRadius: UISBRiskgrade.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBOverview = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Scan Overview</b><br/><br/>
      The Scan Overview section shows you the number of Secure Baseline scans in progress 
      (Active Scans), scans that have been scheduled, scans that are paused, and the total 
      number of targets on your instance that have not yet been scanned.  
      </div>
      <div style={helpimg}>
      <img
        src={UISBOverview.imageUrl}
        alt={'Image of ' + UISBOverview.name}
        style={{
          width: UISBOverview.imageSize,
          borderRadius: UISBOverview.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBTop5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Top 5 Secure Baselines Performed</b><br/><br/>
      The Top 5 Baselines Performed ranks operating systems by the number of machines using that 
      OS that have been scanned since the beginning. The greater the number of devices using a 
      particular OS that were scanned, the higher the OS is ranked. 
      </div>
      <div style={helpimg}>
      <img
        src={UISBTop5.imageUrl}
        alt={'Image of ' + UISBTop5.name}
        style={{
          width: UISBTop5.imageSize,
          borderRadius: UISBTop5.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const SBTrendchart = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Secure Baseline Trend Chart</b><br/><br/>
      The Secure Baseline Trend Chart shows a quick view of the history of scanning efforts over various 
      time periods. Select a reporting period (Week, Month, Quarter or Year) to view risk levels based 
      on scan results over your selected period.
      </div>
      <div style={helpimg}>
      <img
        src={UISBTrendchart.imageUrl}
        alt={'Image of ' + UISBTrendchart.name}
        style={{
          width: UISBTrendchart.imageSize,
          borderRadius: UISBTrendchart.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBTop10 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Top 10 Targets with the Lowest % Pass Score</b><br/><br/>
      The above display illustrates the top 10 scanned targets that have the lowest % pass score. 
      These represent the target machines with the worst scores. The display is filtered by the top 
      10 based on either domain or non-domain (use the dropdown at the top right of the table to select one). 
      </div>
      <div style={helpimg}>
      <img
        src={UISBTop10.imageUrl}
        alt={'Image of ' + UISBTop10.name}
        style={{
          width: UISBTop10.imageSize,
          borderRadius: UISBTop10.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBOSList = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Operating Systems List</b><br/><br/>
      The OS List chart shows the overall average grade by Operating System (color-coded to indicate OS) 
      with OS bars representing the number of machines using that operating system. Select the reporting 
      period at the top right of the chart. 
      </div>
      <div style={helpimg}>
      <img
        src={UISBOSList.imageUrl}
        alt={'Image of ' + UISBOSList.name}
        style={{
          width: UISBOSList.imageSize,
          borderRadius: UISBOSList.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBActivescans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Active Baseline Scans</b><br/><br/>
      This shows any active secure baseline scans that you are currently running for your instance, and the percentage progress on each.
      </div>
      <div style={helpimg}>
      <img
        src={UISBActivescans.imageUrl}
        alt={'Image of ' + UISBActivescans.name}
        style={{
          width: UISBActivescans.imageSize,
          borderRadius: UISBActivescans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBLast5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Last 5 Secure Baseline Scans</b><br/><br/>
      This shows the last 5 secure baseline scans that have been performed for your instance, the 
      individuals who scheduled the scans, and start and end time.
      </div>
      <div style={helpimg}>
      <img
        src={UISBLast5.imageUrl}
        alt={'Image of ' + UISBLast5.name}
        style={{
          width: UISBLast5.imageSize,
          borderRadius: UISBLast5.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBScheduledscans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Scheduled Secure Baseline Scans </b><br/><br/>
      You can see any scheduled secure baseline scans for your instance here. The information 
      displayed includes scan name, whether the scan is scheduled to run once or is recurring, 
      next scan date, and the number of Targets each scan will run on.   
      </div>
      <div style={helpimg}>
      <img
        src={UISBScheduledscans.imageUrl}
        alt={'Image of ' + UISBScheduledscans.name}
        style={{
          width: UISBScheduledscans.imageSize,
          borderRadius: UISBScheduledscans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const SBMitprogress = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Baseline Mitigation Plans in Progress</b><br/><br/>
      The <b>Mitigation Plans</b> display shows you all the mitigation plans in the Secure Baseline scan 
      category that are currently in progress, the individual each plan is assigned to, and the progress percentage for each. 
      </div>
      <div style={helpimg}>
      <img
        src={UISBMitprogress.imageUrl}
        alt={'Image of ' + UISBMitprogress.name}
        style={{
          width: UISBMitprogress.imageSize,
          borderRadius: UISBMitprogress.bradius,
        }}
      />
      </div>
    </div>
  );
};

